import React from 'react';
import { useTranslation } from '../utils/i18n';
import './SuccessModal.css';

interface FailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
}

const FailModal: React.FC<FailModalProps> = ({ isOpen, onClose, onConfirm, message }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-content">
          <div className="modal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
              <circle cx="39" cy="39" r="39" fill="#E74C3C"/>
              <path d="M50 28L28 50M28 28L50 50" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="modal-text">
            {message || t("app.shared.alerts.error.text")}
          </div>
          <div className="modal-actions">
            <button 
              className="btn btn-danger"
              onClick={onConfirm}
            >
              {t("app.shared.alerts.error.confirmButtonText") || "ตกลง"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailModal;
